module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [(false) ? _c('van-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu != 6),
      expression: "formData.jindu!=6"
    }],
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu2.length ? _vm.formData.extra_saiqu2[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "可申请升级赛区",
      "placeholder": "点击选择已报名参赛的赛区"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker2 = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker2,
      "url": "api/sai/clubSaiquOptions",
      "limit": 1,
      "is_online": 2,
      "value": _vm.formData.extra_saiqu2,
      "defaultValue": _vm.formData.extra_saiqu2
    },
    on: {
      "onChange": _vm.onSaiqu2Change,
      "onClose": function($event) {
        _vm.showSaiquPicker2 = false
      },
      "onConfirm": _vm.onSaiqu2Confirm
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu.length ? _vm.formData.extra_saiqu[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "线下领取牌匾的比赛名称",
      "placeholder": "点击选择领取的比赛名称"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker,
      "url": "api/sai/dakejianSaiquOptions",
      "limit": 1,
      "is_online": 2,
      "value": _vm.formData.extra_saiqu,
      "defaultValue": _vm.formData.extra_saiqu
    },
    on: {
      "onChange": _vm.onSaiquChange,
      "onClose": function($event) {
        _vm.showSaiquPicker = false
      },
      "onConfirm": _vm.onSaiquConfirm
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "year",
      "value": _vm.formData.year,
      "input-align": "right",
      "label": "申报年度",
      "placeholder": "点击选择申报年度"
    },
    on: {
      "click": function () {
        _vm.formData.id ? '' : _vm.showDate = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "title": "选择年月",
      "type": "year-month",
      "default-date": new Date((_vm.formData.year ? _vm.formData.year : "").replace(/-/g, "/")),
      "min-date": _vm.minDate
    },
    on: {
      "cancel": function($event) {
        _vm.showDate = false
      },
      "confirm": _vm.onDateConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.type),
            callback: function($$v) {
              _vm.$set(_vm.formData, "type", $$v)
            },
            expression: "formData.type"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 1
          }
        }, [_vm._v("全国校园大课间啦啦操推广示范单位")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "省市区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function () {
        _vm.formData.id ? '' : _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "单位名称",
      "input-align": "right",
      "disabled": _vm.formData.id > 0,
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "disabled": _vm.formData.id > 0,
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '人数不能为空'
      }],
      "error-message-align": "right",
      "label": "全校人数",
      "disabled": _vm.formData.id > 0,
      "type": "number",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入全校人数"
    },
    model: {
      value: (_vm.formData.renshu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "renshu", $$v)
      },
      expression: "formData.renshu"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("先进个人（教师或校长信息）\n      ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "个人姓名（限一人）",
      "disabled": _vm.formData.id > 0,
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.jiaoshi_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jiaoshi_name", $$v)
      },
      expression: "formData.jiaoshi_name"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "活动照片",
      "value": _vm.formData.huodongpic.length + '/5'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.huodongpic,
      "limit": 5,
      "name": 'huodongpic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#F00",
      "font-weight": "bold"
    }
  }, [_vm._v("照片需要5张可以体现出全员啦啦操大课间照片哦")])], 1), _vm._v(" "), _c('van-divider', [_vm._v("联系人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "姓名",
      "disabled": _vm.formData.id > 0,
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机",
      "input-align": "right",
      "clearable": "",
      "disabled": _vm.formData.id > 0,
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          提交报名\n        ")])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-438ec404","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cdakejian/DakejianApplySimple.vue
// module id = 2348
// module chunks = 0